import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export async function isWebXRARSupported() {
  try {
    return !!(navigator.xr && (await navigator.xr.isSessionSupported('immersive-ar')));
  } catch {
    return false;
  }
}

function buildOverlay(sizes, initialId) {
  const root = document.createElement('div');
  root.style.cssText = 'position:fixed;inset:0;z-index:9999;pointer-events:none;font-family:Poppins,sans-serif;';
  const chips = sizes.map((s) =>
    `<button data-size="${s.id}" style="pointer-events:auto;border:none;padding:9px 14px;border-radius:999px;font-size:12px;font-weight:bold;background:${s.id === initialId ? '#00A8E8' : 'rgba(10,36,99,.82)'};color:#fff;">${s.chip}</button>`
  ).join('');
  root.innerHTML = `
    <style>
      @keyframes ar-sweep { 0%{transform:translateX(-34px) rotate(-12deg);} 50%{transform:translateX(34px) rotate(12deg);} 100%{transform:translateX(-34px) rotate(-12deg);} }
    </style>
    <div id="ar-top" style="position:absolute;top:14px;left:0;right:64px;display:flex;flex-direction:column;align-items:flex-start;gap:7px;padding-left:14px;">
      <span style="background:rgba(10,36,99,.82);color:#fff;padding:5px 12px;border-radius:999px;font-size:10px;letter-spacing:.08em;text-transform:uppercase;font-weight:bold;">Escolha o tamanho</span>
      <div style="display:flex;gap:7px;flex-wrap:wrap;">${chips}</div>
    </div>
    <div id="ar-mapping" style="display:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background:rgba(8,20,50,.88);color:#fff;padding:22px 24px;border-radius:18px;text-align:center;max-width:82vw;">
      <div style="width:44px;height:72px;border:3px solid #7DD8FF;border-radius:10px;margin:0 auto 14px;animation:ar-sweep 2.2s ease-in-out infinite;"></div>
      <p style="margin:0;font-size:15px;font-weight:bold;">Mapeie o ambiente</p>
      <p style="margin:7px 0 14px;font-size:12px;color:#BFD7FF;">Movimente o celular devagar para os lados e aponte também para o chão e para a área onde deseja visualizar o painel.</p>
      <div style="height:6px;background:rgba(255,255,255,.18);border-radius:999px;overflow:hidden;">
        <div id="ar-map-bar" style="height:100%;width:0%;background:#00A8E8;border-radius:999px;transition:width .3s;"></div>
      </div>
      <p id="ar-map-status" style="margin:9px 0 0;font-size:11.5px;color:#7DD8FF;">Mapeando ambiente…</p>
    </div>
    <div id="ar-mira" style="display:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:26px;height:26px;border:2px solid rgba(255,255,255,.85);border-radius:50%;box-shadow:0 0 6px rgba(0,0,0,.4);"><span style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:4px;height:4px;background:#00A8E8;border-radius:50%;"></span></div>
    <div style="position:absolute;left:50%;bottom:22px;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;gap:7px;width:92vw;">
      <div id="ar-hint" style="background:rgba(10,36,99,.82);color:#fff;padding:9px 16px;border-radius:999px;font-size:12.5px;text-align:center;max-width:100%;">Movimente o celular devagar pelo ambiente.</div>
      <div style="background:rgba(0,0,0,.55);color:#fff;padding:7px 14px;border-radius:12px;font-size:11px;text-align:center;line-height:1.5;">
        <span id="ar-scale-note">Visualização em escala real aproximada</span><br/>
        <strong id="ar-size-label" style="color:#7DD8FF;"></strong>
      </div>
    </div>
    <div id="ar-err" style="display:none;position:absolute;left:50%;top:70px;transform:translateX(-50%);background:rgba(180,40,40,.9);color:#fff;padding:8px 16px;border-radius:12px;font-size:12px;max-width:88vw;text-align:center;"></div>
    <div id="ar-ok" style="display:none;position:absolute;left:50%;top:70px;transform:translateX(-50%);background:rgba(22,140,70,.92);color:#fff;padding:8px 16px;border-radius:12px;font-size:12px;max-width:88vw;text-align:center;"></div>
    <div id="ar-warn" style="display:none;position:absolute;left:50%;top:70px;transform:translateX(-50%);background:rgba(190,140,20,.94);color:#fff;padding:8px 16px;border-radius:12px;font-size:12px;max-width:88vw;text-align:center;"></div>
    <div id="ar-fit" style="display:none;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background:rgba(120,25,25,.94);color:#fff;padding:20px;border-radius:16px;text-align:center;max-width:80vw;pointer-events:auto;">
      <p style="margin:0 0 14px;font-size:14px;font-weight:bold;">Este painel excede os limites detectados desta área.</p>
      <div style="display:flex;gap:8px;justify-content:center;flex-wrap:wrap;">
        <button id="ar-fit-point" style="border:none;padding:10px 14px;border-radius:999px;font-size:12px;font-weight:bold;background:#00A8E8;color:#fff;">Escolher outro ponto</button>
        <button id="ar-fit-size" style="border:2px solid #7DD8FF;padding:10px 14px;border-radius:999px;font-size:12px;font-weight:bold;background:transparent;color:#7DD8FF;">Escolher tamanho menor</button>
        <button id="ar-fit-force" style="border:2px solid rgba(255,255,255,.6);padding:10px 14px;border-radius:999px;font-size:12px;font-weight:bold;background:transparent;color:#fff;">Visualizar mesmo assim</button>
      </div>
    </div>
    <button id="ar-photo" style="display:none;pointer-events:auto;position:absolute;bottom:118px;right:18px;width:58px;height:58px;border-radius:50%;background:#fff;border:4px solid rgba(255,255,255,.4);box-shadow:0 2px 12px rgba(0,0,0,.4);align-items:center;justify-content:center;">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0A2463" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
    </button>
    <div id="ar-photo-view" style="display:none;position:absolute;inset:0;background:rgba(5,10,25,.96);z-index:3;pointer-events:auto;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:18px;">
      <img id="ar-photo-img" alt="Foto do painel" style="max-width:92vw;max-height:62vh;border-radius:14px;box-shadow:0 6px 30px rgba(0,0,0,.5);" />
      <div style="display:flex;gap:10px;flex-wrap:wrap;justify-content:center;">
        <button id="ar-photo-share" style="border:none;padding:12px 20px;border-radius:999px;font-size:13px;font-weight:bold;background:#25D366;color:#fff;">Enviar / Compartilhar</button>
        <button id="ar-photo-save" style="border:2px solid #7DD8FF;padding:12px 20px;border-radius:999px;font-size:13px;font-weight:bold;background:transparent;color:#7DD8FF;">Salvar</button>
      </div>
      <button id="ar-photo-close" style="position:absolute;top:14px;right:14px;width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;border:none;font-size:20px;line-height:1;">×</button>
    </div>
    <button id="ar-exit" style="pointer-events:auto;position:absolute;top:14px;right:14px;width:42px;height:42px;border-radius:50%;background:rgba(10,36,99,.82);color:#fff;border:none;font-size:20px;line-height:1;z-index:2;">×</button>`;
  document.body.appendChild(root);
  return {
    root,
    showErr: (msg) => {
      const el = root.querySelector('#ar-err');
      el.textContent = msg;
      el.style.display = 'block';
      setTimeout(() => { el.style.display = 'none'; }, 5000);
    },
    showOk: (msg) => {
      const el = root.querySelector('#ar-ok');
      el.textContent = msg;
      el.style.display = 'block';
      setTimeout(() => { el.style.display = 'none'; }, 3500);
    },
    showWarn: (msg) => {
      const el = root.querySelector('#ar-warn');
      el.textContent = msg;
      el.style.display = 'block';
      setTimeout(() => { el.style.display = 'none'; }, 5000);
    },
    showFitDialog: (onOther, onSmaller, onForce) => {
      const el = root.querySelector('#ar-fit');
      el.style.display = 'block';
      root.querySelector('#ar-fit-point').onclick = () => { el.style.display = 'none'; onOther(); };
      root.querySelector('#ar-fit-size').onclick = () => { el.style.display = 'none'; onSmaller(); };
      root.querySelector('#ar-fit-force').onclick = () => { el.style.display = 'none'; onForce && onForce(); };
    },
    setHint: (txt) => { root.querySelector('#ar-hint').textContent = txt; },
    setScaleNote: (txt) => { root.querySelector('#ar-scale-note').textContent = txt; },
    setSizeLabel: (txt) => { root.querySelector('#ar-size-label').textContent = txt; },
    setMira: (on) => { root.querySelector('#ar-mira').style.display = on ? 'block' : 'none'; },
    setMapping: (on) => { root.querySelector('#ar-mapping').style.display = on ? 'block' : 'none'; },
    setMapProgress: (f) => { root.querySelector('#ar-map-bar').style.width = `${Math.round(f * 100)}%`; },
    setMapStatus: (txt) => { root.querySelector('#ar-map-status').textContent = txt; },
    setPhotoBtn: (on) => { root.querySelector('#ar-photo').style.display = on ? 'flex' : 'none'; },
    onPhoto: (cb) => { root.querySelector('#ar-photo').onclick = cb; },
    isPhotoOpen: () => root.querySelector('#ar-photo-view').style.display !== 'none',
    showPhoto: (blob) => {
      const url = URL.createObjectURL(blob);
      const view = root.querySelector('#ar-photo-view');
      root.querySelector('#ar-photo-img').src = url;
      view.style.display = 'flex';
      root.querySelector('#ar-photo-close').onclick = () => { view.style.display = 'none'; URL.revokeObjectURL(url); };
      const download = () => { const a = document.createElement('a'); a.href = url; a.download = 'painel-led-tomaselli.jpg'; a.click(); };
      root.querySelector('#ar-photo-save').onclick = download;
      root.querySelector('#ar-photo-share').onclick = async () => {
        const file = new File([blob], 'painel-led-tomaselli.jpg', { type: 'image/jpeg' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          try { await navigator.share({ files: [file], title: 'Painel de LED — Grupo Tomaselli' }); } catch {}
        } else download();
      };
    },
    setActiveChip: (id) => {
      root.querySelectorAll('[data-size]').forEach((b) => {
        b.style.background = b.dataset.size === id ? '#00A8E8' : 'rgba(10,36,99,.82)';
      });
    },
    destroy: () => { try { document.body.removeChild(root); } catch {} },
  };
}

function makeProvisional(W, H) {
  const grp = new THREE.Group();
  const D = 0.09, BASE = 0.03;
  const body = new THREE.Mesh(new THREE.BoxGeometry(W, H, D), new THREE.MeshBasicMaterial({ color: 0x0b0b0d }));
  body.position.y = BASE + H / 2;
  grp.add(body);
  const front = new THREE.Mesh(new THREE.PlaneGeometry(W - 0.024, H - 0.024), new THREE.MeshBasicMaterial({ color: 0x0a2463 }));
  front.position.set(0, BASE + H / 2, D / 2 + 0.002);
  front.name = 'ProvisionalScreen';
  grp.add(front);
  grp.traverse((o) => { o.frustumCulled = false; });
  return grp;
}

function makeShadow(W, H) {
  const c = document.createElement('canvas');
  c.width = 256; c.height = 128;
  const ctx = c.getContext('2d');
  const g = ctx.createRadialGradient(128, 64, 8, 128, 64, 120);
  g.addColorStop(0, 'rgba(0,0,0,0.32)');
  g.addColorStop(0.7, 'rgba(0,0,0,0.12)');
  g.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 256, 128);
  const tex = new THREE.CanvasTexture(c);
  const m = new THREE.Mesh(
    new THREE.PlaneGeometry(W * 1.15, 1.3),
    new THREE.MeshBasicMaterial({ map: tex, transparent: true, depthWrite: false })
  );
  m.rotation.x = -Math.PI / 2;
  m.position.set(0, 0.004, -0.15);
  m.renderOrder = 1;
  m.frustumCulled = false;
  return m;
}

function drawCover(ctx, src, W, H) {
  const sw = src.videoWidth || src.width, sh = src.videoHeight || src.height;
  if (!sw || !sh) return;
  const s = Math.max(W / sw, H / sh);
  ctx.drawImage(src, (W - sw * s) / 2, (H - sh * s) / 2, sw * s, sh * s);
}

function stampPhoto(ctx, W, H) {
  const fs = Math.max(Math.round(W * 0.026), 14);
  ctx.font = `bold ${fs}px Poppins, sans-serif`;
  ctx.fillStyle = 'rgba(0,0,0,.45)';
  ctx.fillRect(0, H - fs * 2.4, W, fs * 2.4);
  ctx.fillStyle = 'rgba(255,255,255,.92)';
  ctx.fillText('Grupo Tomaselli · simulação de painel de LED', fs, H - fs * 0.9);
}

function applyGlbTexture(model, tex) {
  tex.flipY = false;
  tex.colorSpace = THREE.SRGBColorSpace;
  model.traverse((o) => {
    if (o.isMesh && o.material && o.material.name === 'ScreenMat') {
      o.material.map = tex;
      o.material.emissiveMap = tex;
      o.material.emissive = new THREE.Color(0xffffff);
      o.material.needsUpdate = true;
    }
  });
}

function attachGestures(root, panel, getCamera, onTap) {
  let moved = false, lastT = null, twist = null;
  const d2 = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
  const a2 = (a, b) => Math.atan2(b.clientY - a.clientY, b.clientX - a.clientX);
  root.style.pointerEvents = 'auto';
  root.addEventListener('touchstart', (e) => {
    if (e.target.closest('button')) return;
    moved = false;
    if (e.touches.length === 1) lastT = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    if (e.touches.length === 2) twist = { a: a2(e.touches[0], e.touches[1]), r: panel.rotation.y, d: d2(e.touches[0], e.touches[1]) };
  }, { passive: true });
  root.addEventListener('touchmove', (e) => {
    const cam = getCamera();
    if (e.touches.length === 1 && lastT && !twist) {
      const dx = e.touches[0].clientX - lastT.x;
      const dy = e.touches[0].clientY - lastT.y;
      if (Math.hypot(dx, dy) > 8) moved = true;
      lastT = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      if (panel.visible && cam) {
        const fwd = new THREE.Vector3();
        cam.getWorldDirection(fwd);
        fwd.y = 0;
        if (fwd.lengthSq() < 1e-4) fwd.set(0, 0, -1); else fwd.normalize();
        const right = new THREE.Vector3().crossVectors(fwd, new THREE.Vector3(0, 1, 0)).negate();
        const cp = new THREE.Vector3();
        cam.getWorldPosition(cp);
        const d = Math.max(panel.position.distanceTo(cp), 1);
        panel.position.addScaledVector(right, dx * 0.0022 * d);
        panel.position.addScaledVector(fwd, -dy * 0.0035 * d);
        panel.updateMatrixWorld(true);
      }
    } else if (e.touches.length === 2 && twist) {
      moved = true;
      // apenas rotação — redimensionamento livre bloqueado
      const na = a2(e.touches[0], e.touches[1]);
      panel.rotation.y = twist.r - (na - twist.a);
      panel.updateMatrixWorld(true);
    }
  }, { passive: true });
  root.addEventListener('touchend', (e) => {
    if (e.touches.length < 2) twist = null;
    if (e.touches.length === 0) {
      if (!moved && lastT !== null && onTap) onTap(lastT.x, lastT.y);
      lastT = null;
    }
  }, { passive: true });
  return { wasMoved: () => moved };
}

export async function startAR({ sizes, initialId, customTexFor, onEnd }) {
  const ui = buildOverlay(sizes, initialId);

  const scene = new THREE.Scene();
  scene.add(new THREE.HemisphereLight(0xffffff, 0x999999, 1.4));
  const dl = new THREE.DirectionalLight(0xffffff, 1.1);
  dl.position.set(1, 4, 2);
  scene.add(dl);

  const panel = new THREE.Group();
  const content = new THREE.Group();
  panel.add(content);
  scene.add(panel);

  let current = sizes.find((s) => s.id === initialId) || sizes[0];
  let shadow = null;
  const texLoader = new THREE.TextureLoader();
  const gltfLoader = new GLTFLoader();
  let loadSeq = 0;

  const setShadow = (size) => {
    if (shadow) panel.remove(shadow);
    shadow = makeShadow(size.W, size.H);
    panel.add(shadow);
  };

  const provisional = makeProvisional(current.W, current.H);
  content.add(provisional);
  setShadow(current);
  ui.setSizeLabel(`Painel: ${current.label}`);
  const provTexUrl = customTexFor(current) || current.texUrl;
  texLoader.loadAsync(provTexUrl).then((tex) => {
    tex.colorSpace = THREE.SRGBColorSpace;
    const scr = provisional.getObjectByName('ProvisionalScreen');
    if (scr && scr.parent) scr.material = new THREE.MeshBasicMaterial({ map: tex });
  }).catch(() => {});

  const loadSize = async (size) => {
    current = size;
    ui.setActiveChip(size.id);
    ui.setSizeLabel(`Painel: ${size.label}`);
    const seq = ++loadSeq;
    try {
      const gltf = await gltfLoader.loadAsync(size.glbUrl);
      if (seq !== loadSeq) return;
      const custom = customTexFor(size);
      if (custom) {
        try { applyGlbTexture(gltf.scene, await texLoader.loadAsync(custom)); }
        catch { ui.showErr('Não foi possível aplicar sua imagem. Exibindo arte padrão.'); }
      }
      gltf.scene.traverse((o) => {
        o.frustumCulled = false;
        if (o.isMesh && o.material) o.material.side = THREE.DoubleSide;
      });
      content.clear();
      content.add(gltf.scene);
      setShadow(size);
      panel.scale.set(1, 1, 1);
      panel.updateMatrixWorld(true);
      scene.updateMatrixWorld(true);
    } catch (e) {
      if (seq === loadSeq) ui.showErr('Não foi possível carregar este tamanho. Tente novamente.');
    }
  };
  loadSize(current);

  ui.root.querySelectorAll('[data-size]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const s = sizes.find((x) => x.id === btn.dataset.size);
      if (s && s.id !== current.id) loadSize(s);
    });
  });

  let cleanupDone = false;
  const finish = (extraCleanup) => {
    if (cleanupDone) return;
    cleanupDone = true;
    try { extraCleanup && extraCleanup(); } catch {}
    ui.destroy();
    if (onEnd) onEnd();
  };

  const xrSupported = await isWebXRARSupported();
  if (xrSupported) {
    try {
      ui.setScaleNote('Visualização em escala real aproximada');
      await runWebXR({ scene, panel, ui, finish, getSize: () => current });
      return;
    } catch (e) { /* cai no fallback */ }
  }
  ui.setScaleNote('Visualização ilustrativa — a escala pode variar neste dispositivo.');
  await runFallback({ scene, panel, ui, finish });
}

function runWebXR({ scene, panel, ui, finish, getSize }) {
  return new Promise(async (resolve, reject) => {
    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.xr.enabled = true;

    let session;
    try {
      session = await navigator.xr.requestSession('immersive-ar', {
        requiredFeatures: [],
        optionalFeatures: ['hit-test', 'dom-overlay', 'local-floor', 'plane-detection', 'camera-access'],
        domOverlay: { root: ui.root },
      });
    } catch (e) { renderer.dispose(); reject(e); return; }

    try {
      renderer.xr.setReferenceSpaceType('local-floor');
      await renderer.xr.setSession(session);
    } catch (e) {
      try { renderer.xr.setReferenceSpaceType('local'); await renderer.xr.setSession(session); }
      catch (e2) { try { session.end(); } catch {} renderer.dispose(); reject(e2); return; }
    }

    const camera = new THREE.PerspectiveCamera(70, 1, 0.01, 100);
    camera.layers.enableAll();
    camera.updateProjectionMatrix();
    panel.visible = false;

    // ===== FLUXO: MAPPING -> READY_TO_PLACE -> PANEL_PLACED =====
    let state = 'MAPPING';
    let mapDone = false;
    let poseFrames = 0;
    let hitFrames = 0;
    let minYaw = Infinity, maxYaw = -Infinity;
    ui.setMapping(true);
    ui.setHint('Mapeie o ambiente antes de posicionar o painel.');
    const mapTimeout = setTimeout(() => { if (state === 'MAPPING') finishMapping(); }, 12000);

    const camPos = new THREE.Vector3();
    const camDir = new THREE.Vector3();
    const placeInFront = (dist = 2.5) => {
      const xcam = renderer.xr.getCamera();
      xcam.getWorldPosition(camPos);
      xcam.getWorldDirection(camDir);
      if (camDir.lengthSq() < 1e-6) camDir.set(0, 0, -1);
      camDir.y = 0;
      camDir.normalize();
      const target = camPos.clone().addScaledVector(camDir, dist);
      panel.position.set(target.x, 0, target.z);
      panel.rotation.y = Math.atan2(camPos.x - target.x, camPos.z - target.z);
      panel.visible = true;
      panel.updateMatrixWorld(true);
      scene.updateMatrixWorld(true);
    };

    // posiciona no ponto do hit-test respeitando o tipo de superfície
    const placeAtHit = (matrix) => {
      const p = new THREE.Vector3().setFromMatrixPosition(matrix);
      const n = new THREE.Vector3().setFromMatrixColumn(new THREE.Matrix4().copy(matrix), 1).normalize();
      const xcam = renderer.xr.getCamera();
      xcam.getWorldPosition(camPos);
      if (Math.abs(n.y) < 0.5) {
        // superfície vertical (parede/fundo): painel no piso, encostado à parede, nunca atrás dela
        panel.position.set(p.x, 0, p.z);
      } else {
        // plano horizontal (piso)
        panel.position.copy(p);
      }
      panel.rotation.y = Math.atan2(camPos.x - panel.position.x, camPos.z - panel.position.z);
      panel.visible = true;
      panel.updateMatrixWorld(true);
    };

    const finishMapping = () => {
      if (mapDone) return;
      mapDone = true;
      clearTimeout(mapTimeout);
      ui.setMapProgress(1);
      ui.setMapStatus('Ambiente pronto ✓');
      setTimeout(() => {
        ui.setMapping(false);
        state = 'READY_TO_PLACE';
        ui.setHint('Toque no local onde deseja posicionar o painel.');
      }, 900);
    };

    let hitTestSource = null;
    session.requestReferenceSpace('viewer').then((vs) =>
      session.requestHitTestSource ? session.requestHitTestSource({ space: vs }) : null
    ).then((src) => { hitTestSource = src; }).catch(() => {});

    const reticle = new THREE.Mesh(
      new THREE.RingGeometry(0.1, 0.13, 32).rotateX(-Math.PI / 2),
      new THREE.MeshBasicMaterial({ color: 0x00a8e8, transparent: true, opacity: 0.85 })
    );
    reticle.matrixAutoUpdate = false;
    reticle.visible = false;
    scene.add(reticle);

    // marcação do espaço necessário (W x 0,8 m) que segue o reticle
    let footprint = new THREE.Mesh(
      new THREE.PlaneGeometry(1, 0.8).rotateX(-Math.PI / 2),
      new THREE.MeshBasicMaterial({ color: 0x00a8e8, transparent: true, opacity: 0.22, side: THREE.DoubleSide, depthWrite: false })
    );
    footprint.visible = false;
    footprint.frustumCulled = false;
    scene.add(footprint);
    footprint.userData.W = 0;

    // valida CABIMENTO ESTRUTURAL (parede/teto/paredes laterais), ignorando mobiliário
    const checkFit = (frame, hitMatrix, W, H) => {
      try {
        const refSpace = renderer.xr.getReferenceSpace();
        const planes = frame.detectedPlanes;
        if (!planes || planes.size === 0 || !refSpace) return { status: 'unknown' };
        const hitP = new THREE.Vector3().setFromMatrixPosition(hitMatrix);
        const xcam = renderer.xr.getCamera();
        xcam.getWorldPosition(camPos);
        const dir = hitP.clone().sub(camPos); dir.y = 0;
        if (dir.lengthSq() < 1e-6) dir.set(0, 0, -1); else dir.normalize();
        const axis = new THREE.Vector3().crossVectors(new THREE.Vector3(0, 1, 0), dir).normalize();
        const floorY = Math.min(0, hitP.y);
        let ceilY = null;
        let wall = null;
        let leftWall = null, rightWall = null;
        let sawAny = false;
        planes.forEach((plane) => {
          const pose = frame.getPose(plane.planeSpace, refSpace);
          if (!pose || !plane.polygon || plane.polygon.length < 3) return;
          sawAny = true;
          const m = new THREE.Matrix4().fromArray(pose.transform.matrix);
          const pts = plane.polygon.map((pt) => new THREE.Vector3(pt.x, pt.y, pt.z).applyMatrix4(m));
          let minY = Infinity, maxY = -Infinity;
          pts.forEach((p) => { minY = Math.min(minY, p.y); maxY = Math.max(maxY, p.y); });
          const horizontal = plane.orientation ? plane.orientation === 'horizontal' : (maxY - minY) < 0.15;
          if (horizontal) {
            // só conta como TETO se estiver a altura de teto real (>= 2,3 m do CHÃO) e for um plano grande
            // tampos de guarda-roupa/armário/mesa são ignorados
            const avgY = (minY + maxY) / 2;
            let area = 0;
            for (let i = 0; i < pts.length; i++) {
              const a = pts[i], b = pts[(i + 1) % pts.length];
              area += a.x * b.z - b.x * a.z;
            }
            area = Math.abs(area) / 2;
            if (avgY - floorY >= 2.3 && area >= 1.5) ceilY = ceilY === null ? avgY : Math.min(ceilY, avgY);
            return;
          }
          // plano VERTICAL (parede/limite estrutural)
          let minS = Infinity, maxS = -Infinity, minF = Infinity, maxF = -Infinity;
          pts.forEach((p) => {
            const rel = p.clone().sub(hitP);
            const s = rel.dot(axis), f = rel.dot(dir);
            minS = Math.min(minS, s); maxS = Math.max(maxS, s);
            minF = Math.min(minF, f); maxF = Math.max(maxF, f);
          });
          const spanS = maxS - minS, spanF = maxF - minF, hgt = maxY - minY;
          const midS = (minS + maxS) / 2, midF = (minF + maxF) / 2;
          // parede PRINCIPAL: predominantemente lateral, próxima/atrás do ponto e cobrindo-o lateralmente
          if (spanS >= spanF && midF > -0.8 && midF < 4 && minS < 0.6 && maxS > -0.6) {
            if (!wall || spanS > wall.width) wall = { width: spanS, topY: maxY, hgt };
          }
          // paredes LATERAIS estruturais: só planos verticais GRANDES (altura de parede, longos)
          // móveis (guarda-roupa, cabeceira) não contam
          if (spanF > spanS && spanF > 2.0 && hgt > 1.8) {
            if (midS < -0.2) leftWall = leftWall === null ? midS : Math.max(leftWall, midS);
            else if (midS > 0.2) rightWall = rightWall === null ? midS : Math.min(rightWall, midS);
          }
        });
        if (!sawAny) return { status: 'unknown' };
        // VERMELHO somente com evidência estrutural inequívoca (medida a partir do CHÃO)
        const headroom = ceilY === null ? null : ceilY - floorY;
        if (headroom !== null && headroom < H - 0.05) return { status: 'nofit' };
        if (leftWall !== null && rightWall !== null && (rightWall - leftWall) < W - 0.2) return { status: 'nofit' };
        // VERDE: parede principal comprova largura + altura disponível
        const heightOk = (headroom !== null && headroom >= H) || (wall && (wall.topY - floorY) >= H - 0.1);
        if (wall && wall.width >= W - 0.1 && heightOk) return { status: 'fits' };
        // AMARELO: há planos mapeados, mas sem confirmação estrutural conclusiva (obstáculos, varredura parcial)
        return { status: 'maybe' };
      } catch {
        return { status: 'unknown' };
      }
    };

    const gestures = attachGestures(ui.root, panel, () => renderer.xr.getCamera(), null);
    ui.root.addEventListener('beforexrselect', (e) => {
      if (e.target && e.target.closest && e.target.closest('button, #ar-photo-view, #ar-fit')) e.preventDefault();
    });
    session.addEventListener('select', (ev) => {
      if (state === 'MAPPING' || ui.isPhotoOpen() || gestures.wasMoved()) return;
      const cur = getSize();
      if (reticle.visible) {
        const res = ev.frame ? checkFit(ev.frame, reticle.matrix, cur.W, cur.H) : { status: 'unknown' };
        if (res.status === 'nofit') {
          const hitSnap = reticle.matrix.clone();
          ui.showFitDialog(
            () => ui.setHint('Toque em outro local para posicionar o painel.'),
            () => ui.setHint('Escolha um tamanho menor no topo da tela.'),
            () => {
              placeAtHit(hitSnap);
              state = 'PANEL_PLACED';
              ui.setPhotoBtn(true);
              ui.showWarn('Visualização aproximada — os limites detectados indicam espaço menor que o painel.');
              ui.setHint('Toque em outro ponto para reposicionar.');
            }
          );
          return;
        }
        placeAtHit(reticle.matrix);
        state = 'PANEL_PLACED';
        ui.setPhotoBtn(true);
        if (res.status === 'fits') {
          ui.showOk('Este painel cabe nesta área ✓');
        } else if (res.status === 'maybe') {
          ui.showWarn('Espaço aparentemente compatível. Existem obstáculos ou a medição não é conclusiva.');
        } else {
          ui.showWarn('Não foi possível confirmar completamente as dimensões desta área. Visualização aproximada.');
        }
      } else {
        placeInFront(2.5);
        state = 'PANEL_PLACED';
        ui.setPhotoBtn(true);
        ui.showWarn('Não foi possível confirmar completamente as dimensões desta área. Visualização aproximada.');
      }
      ui.setHint('Toque em outro ponto para reposicionar.');
    });

    // ===== CAPTURA DE FOTO (câmera real via camera-access + painel 3D) =====
    let glBinding = null;
    let captureReq = false;
    ui.onPhoto(() => { captureReq = true; });
    const capturePhoto = (frame) => {
      const gl = renderer.getContext();
      const refSpace = renderer.xr.getReferenceSpace();
      const pose = refSpace ? frame.getViewerPose(refSpace) : null;
      const dpr = Math.min(window.devicePixelRatio, 2);
      const CW = Math.round(window.innerWidth * dpr), CH = Math.round(window.innerHeight * dpr);
      const cap = document.createElement('canvas'); cap.width = CW; cap.height = CH;
      const c2 = cap.getContext('2d');
      c2.fillStyle = '#0a0f1c'; c2.fillRect(0, 0, CW, CH);
      try {
        const view = pose && pose.views.find((v) => v.camera);
        if (view && window.XRWebGLBinding) {
          if (!glBinding) glBinding = new XRWebGLBinding(session, gl);
          const camTex = glBinding.getCameraImage(view.camera);
          const cw = view.camera.width, ch = view.camera.height;
          const fb = gl.createFramebuffer();
          const prev = gl.getParameter(gl.FRAMEBUFFER_BINDING);
          gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
          gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, camTex, 0);
          if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE) {
            const px = new Uint8Array(cw * ch * 4);
            gl.readPixels(0, 0, cw, ch, gl.RGBA, gl.UNSIGNED_BYTE, px);
            const img = new ImageData(cw, ch);
            for (let y = 0; y < ch; y++) img.data.set(px.subarray((ch - 1 - y) * cw * 4, (ch - y) * cw * 4), y * cw * 4);
            const tmp = document.createElement('canvas'); tmp.width = cw; tmp.height = ch;
            tmp.getContext('2d').putImageData(img, 0, 0);
            drawCover(c2, tmp, CW, CH);
          }
          gl.bindFramebuffer(gl.FRAMEBUFFER, prev);
          gl.deleteFramebuffer(fb);
        }
      } catch {}
      const src = renderer.xr.getCamera();
      const base = src.cameras && src.cameras.length ? src.cameras[0] : src;
      const snapCam = new THREE.PerspectiveCamera();
      snapCam.matrixAutoUpdate = false;
      snapCam.matrix.copy(base.matrixWorld);
      snapCam.matrixWorld.copy(base.matrixWorld);
      snapCam.projectionMatrix.copy(base.projectionMatrix);
      snapCam.projectionMatrixInverse.copy(base.projectionMatrix).invert();
      const rv = reticle.visible, fv = footprint.visible;
      reticle.visible = false; footprint.visible = false;
      const off = new THREE.WebGLRenderer({ alpha: true, antialias: true, preserveDrawingBuffer: true });
      off.setPixelRatio(1);
      off.setSize(CW, CH, false);
      off.render(scene, snapCam);
      reticle.visible = rv; footprint.visible = fv;
      c2.drawImage(off.domElement, 0, 0, CW, CH);
      off.dispose();
      stampPhoto(c2, CW, CH);
      cap.toBlob((b) => { if (b) ui.showPhoto(b); else ui.showErr('Não foi possível capturar a foto.'); }, 'image/jpeg', 0.92);
    };

    let settled = false;
    const watchdog = setTimeout(() => {
      if (poseFrames === 0 && !settled) {
        settled = true;
        try { session.end(); } catch {}
        renderer.setAnimationLoop(null);
        renderer.dispose();
        reject(new Error('webxr sem pose válida'));
      }
    }, 4000);

    renderer.setAnimationLoop((time, frame) => {
      if (!frame) return;
      const refSpace = renderer.xr.getReferenceSpace();
      const pose = refSpace ? frame.getViewerPose(refSpace) : null;
      if (pose) {
        poseFrames += 1;
        if (!settled) { settled = true; clearTimeout(watchdog); resolve(); }
      }
      let hasHit = false;
      if (hitTestSource && refSpace) {
        const hits = frame.getHitTestResults(hitTestSource);
        if (hits.length > 0) {
          const hp = hits[0].getPose(refSpace);
          if (hp) {
            hasHit = true;
            reticle.visible = true;
            reticle.matrix.fromArray(hp.transform.matrix);
          }
        } else {
          reticle.visible = false;
        }
      }
      // marcação do espaço necessário segue o reticle (após o mapeamento)
      if (state === 'MAPPING') reticle.visible = false;
      if (state !== 'MAPPING' && reticle.visible) {
        const cur = getSize();
        if (footprint.userData.W !== cur.W) {
          footprint.geometry.dispose();
          footprint.geometry = new THREE.PlaneGeometry(cur.W, 0.8).rotateX(-Math.PI / 2);
          footprint.userData.W = cur.W;
        }
        const hp2 = new THREE.Vector3().setFromMatrixPosition(reticle.matrix);
        const xcam2 = renderer.xr.getCamera();
        xcam2.getWorldPosition(camPos);
        footprint.position.set(hp2.x, hp2.y + 0.01, hp2.z);
        footprint.rotation.y = Math.atan2(camPos.x - hp2.x, camPos.z - hp2.z);
        footprint.visible = true;
      } else {
        footprint.visible = false;
      }
      if (state === 'MAPPING' && pose) {
        if (hasHit) hitFrames += 1;
        const xcam = renderer.xr.getCamera();
        xcam.getWorldDirection(camDir);
        const yaw = Math.atan2(camDir.x, camDir.z);
        if (Number.isFinite(yaw)) { minYaw = Math.min(minYaw, yaw); maxYaw = Math.max(maxYaw, yaw); }
        const yawSpan = maxYaw > minYaw ? Math.min(maxYaw - minYaw, 0.7) : 0;
        const prog = 0.35 * Math.min(poseFrames / 110, 1) + 0.35 * Math.min(hitFrames / 70, 1) + 0.3 * (yawSpan / 0.7);
        if (poseFrames % 8 === 0) ui.setMapProgress(Math.min(prog, 0.98));
        if (prog >= 1) finishMapping();
      }
      // painel só existe visível em PANEL_PLACED e sempre em escala mundial 1:1
      panel.scale.set(1, 1, 1);
      if (state !== 'PANEL_PLACED') panel.visible = false;
      renderer.render(scene, camera);
      if (captureReq) {
        captureReq = false;
        if (state === 'PANEL_PLACED') {
          try { capturePhoto(frame); } catch { ui.showErr('Não foi possível capturar a foto.'); }
        }
      }
    });

    session.addEventListener('end', () => {
      clearTimeout(mapTimeout);
      if (!settled) { settled = true; clearTimeout(watchdog); reject(new Error('sessão encerrada')); return; }
      renderer.setAnimationLoop(null);
      scene.remove(reticle);
      finish(() => renderer.dispose());
    });
    ui.root.querySelector('#ar-exit').onclick = () => { try { session.end(); } catch { finish(() => renderer.dispose()); } };
  });
}

async function runFallback({ scene, panel, ui, finish }) {
  const video = document.createElement('video');
  video.setAttribute('playsinline', '');
  video.playsInline = true;
  video.muted = true;
  video.autoplay = true;
  video.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;object-fit:cover;z-index:9990;background:#000;';
  document.body.appendChild(video);

  let stream = null;
  try {
    stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment', width: { ideal: 1920 } }, audio: false });
    video.srcObject = stream;
    await video.play();
  } catch (e) {
    ui.showErr('Não foi possível acessar a câmera. Verifique a permissão no navegador.');
  }

  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100dvh;z-index:9991;background:transparent;pointer-events:none;';
  document.body.appendChild(canvas);
  let renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  } catch (e) {
    ui.showErr('Seu navegador não suporta visualização 3D (WebGL).');
    finish(() => { stream?.getTracks().forEach((t) => t.stop()); video.remove(); canvas.remove(); });
    return;
  }
  canvas.addEventListener('webglcontextlost', (e) => { e.preventDefault(); ui.showErr('Visualização interrompida. Feche e abra novamente.'); });

  const camera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.05, 100);
  camera.position.set(0, 1.5, 0);
  const setSize = () => {
    renderer.setSize(window.innerWidth, window.innerHeight, false);
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
  };
  setSize();
  window.addEventListener('resize', setSize);
  window.addEventListener('orientationchange', setSize);
  const onVis = () => { if (document.visibilityState === 'visible' && video.paused) video.play().catch(() => {}); };
  document.addEventListener('visibilitychange', onVis);

  // ===== FLUXO: MAPPING -> READY_TO_PLACE -> PANEL_PLACED =====
  camera.lookAt(0, 0.9, -4);
  let state = 'MAPPING';
  panel.visible = false;
  ui.setMapping(true);
  ui.setHint('Mapeie o ambiente antes de posicionar o painel.');
  let mapProg = 0;
  const mapInt = setInterval(() => {
    mapProg = Math.min(mapProg + 0.09, 1);
    ui.setMapProgress(mapProg);
    if (mapProg >= 1) {
      clearInterval(mapInt);
      ui.setMapStatus('Ambiente pronto ✓');
      setTimeout(() => {
        ui.setMapping(false);
        state = 'READY_TO_PLACE';
        ui.setMira(true);
        ui.setHint('Toque no local onde deseja posicionar o painel.');
      }, 900);
    }
  }, 450);

  const ray = new THREE.Raycaster();
  const floor = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
  attachGestures(ui.root, panel, () => camera, (x, y) => {
    if (state === 'MAPPING') return;
    const ndc = new THREE.Vector2((x / window.innerWidth) * 2 - 1, -(y / window.innerHeight) * 2 + 1);
    ray.setFromCamera(ndc, camera);
    const p = new THREE.Vector3();
    if (ray.ray.intersectPlane(floor, p) && p.distanceTo(camera.position) < 20) {
      panel.position.set(p.x, 0, p.z);
      panel.rotation.y = Math.atan2(camera.position.x - p.x, camera.position.z - p.z);
      panel.visible = true;
      state = 'PANEL_PLACED';
      panel.updateMatrixWorld(true);
      ui.setMira(false);
      ui.setPhotoBtn(true);
      ui.showWarn('Não foi possível confirmar completamente as dimensões desta área. Visualização aproximada.');
      ui.setHint('Toque em outro ponto para reposicionar.');
    }
  });

  ui.onPhoto(() => {
    const CW = canvas.width, CH = canvas.height;
    const cap = document.createElement('canvas'); cap.width = CW; cap.height = CH;
    const c2 = cap.getContext('2d');
    c2.fillStyle = '#0a0f1c'; c2.fillRect(0, 0, CW, CH);
    if (video.videoWidth) drawCover(c2, video, CW, CH);
    renderer.render(scene, camera);
    c2.drawImage(renderer.domElement, 0, 0, CW, CH);
    stampPhoto(c2, CW, CH);
    cap.toBlob((b) => { if (b) ui.showPhoto(b); }, 'image/jpeg', 0.92);
  });

  renderer.setAnimationLoop(() => {
    panel.scale.set(1, 1, 1);
    if (state !== 'PANEL_PLACED') panel.visible = false;
    renderer.render(scene, camera);
  });

  ui.root.querySelector('#ar-exit').onclick = () => {
    clearInterval(mapInt);
    renderer.setAnimationLoop(null);
    window.removeEventListener('resize', setSize);
    window.removeEventListener('orientationchange', setSize);
    document.removeEventListener('visibilitychange', onVis);
    finish(() => {
      stream?.getTracks().forEach((t) => t.stop());
      video.remove();
      canvas.remove();
      renderer.dispose();
    });
  };
}
